<template>
    <b-form class="otp-form mx-auto"
            @submit.stop.prevent="verifyOtp">
        <div class="px-3 py-4 background spacing radius"
             v-if="!edit">
            <b-row class="mb-1 mx-0 d-flex align-items-center">
                <b-col sm="4"
                       class="px-0">
                    <div class="label font-weight-bold">請輸入一次性密碼</div>
                </b-col>
                <b-col sm="8"
                       class="px-0">
                    <b-form-input v-model.trim="$v.otp.$model"
                                  :state="validateState()"
                                  placeholder="請輸入您收到的一次性密碼(共6碼)"
                                  autocomplete="off"></b-form-input>
                </b-col>
            </b-row>
            <div class="otp-text">
                若您已超過5分鐘仍未收到一次性密碼，請再按一次
                <a v-on:click="debounce"
                   data-ga="新保險網站_查預約_重新發送一次性密碼"
                   class="text-primary">重新發送一次性密碼
                </a>
            </div>
        </div>
        <div class="d-flex flex-row justify-content-around align-items-center my-5"
             v-if="!edit">
            <b-button pill
                      variant="outline-primary"
                      class="global-button"
                      data-ga-element="新保險網站_查預約_修改資料"
                      v-on:click="editForm">修改資料</b-button>
            <b-button pill
                      type="submit"
                      variant="primary"
                      data-ga-element="新保險網站_查預約_完成送出"
                      class="global-button">完成送出</b-button>
        </div>

        <Modal :show="show"
               :description="description"
               @onClose="onClose">
            <div slot="action"
                 class="d-flex justify-content-center align-items-center my-5">
                <b-button pill
                          variant="primary"
                          class="button"
                          v-on:click="onClose">{{buttonText}}</b-button>
            </div>
        </Modal>
        <Notification />
    </b-form>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { request } from '@/service';
import lodash from 'lodash';
import Modal from '@/components/Modal.vue';
import Notification from '@/components/Notification.vue';

const lengthCheck = (value) => {
    const pattern = /^\d{6}$/;
    return pattern.test(value);
};

export default {
    mixins: [validationMixin],
    name: 'Otp',
    components: {
        Modal,
        Notification
    },
    props: {
        cellphone: String,
        edit: Boolean,
        otpCallback: Function,
        editCallback: Function,
    },
    data() {
        return {
            show: false,
            buttonText: '',
            isError: false,
            otp: '',
            otpCodeUUID: null,
            resendCount: 0,
            description: '',
        };
    },
    created() {
        this.debounce = lodash.debounce(this.resend, 1000);
    },
    watch: {
        edit(val) {
            if (!val) {
                this.requestOtp(val);
            }
        }
    },
    validations: {
        otp: {
            required,
            lengthCheck
        }
    },
    methods: {
        onClose() {
            this.show = false;
            const protocol = window.location.protocol;
            const host = window.location.host;
            window.location.href = `${protocol}//${host}/fubonagent`;
        },
        validateState() {
            const { $dirty, $error } = this.$v.otp;
            return $dirty ? !$error : null;
        },
        requestOtp() {
            request({
                base: true,
                method: 'POST',
                api: '/api/apiRequestOtp',
                data: { cellphone: this.cellphone }
            })
                .then(res => {
                    this.$notify({
                        group: 'alert',
                        title: '一次性密碼已發送至手機',
                        type: 'success',
                    });
                    this.otpCodeUUID = res.data.otpCodeUUID;
                }).catch((e) => {
                    // error: edit error toast text
                    if (e.status === 500) {
                        this.$notify({
                            group: 'alert',
                            title: e.message,
                            type: 'error',
                        });
                    }
                });
        },
        resend() {
            // 此驗證碼已失效，請再按一次重發送一次密碼
            if (this.resendCount === 10) {
                this.buttonText = '確認';
                this.isError = true;
                this.description = '發送一次性密碼超過十次，將會導頁至新保險網站首頁';
                this.edit = true;
            } else {
                request({
                    base: true,
                    method: 'POST',
                    api: '/api/apiResendOtp',
                    data: {
                        cellphone: this.cellphone,
                        otpCodeUUID: this.otpCodeUUID
                    }
                })
                    .then(res => {
                        this.resendCount = res.data.resendCount;
                        this.$notify({
                            group: 'alert',
                            title: '已重新發送一次性密碼',
                            type: 'success',
                        });
                        this.otpCodeUUID = res.data.otpCodeUUID;
                    }).catch((e) => {
                        // error: edit error toast text
                        this.$notify({
                            group: 'alert',
                            title: '系統發生錯誤',
                            type: 'error',
                        });
                    });
            }
        },
        // otp 進行驗證
        verifyOtp() {
            this.$v.otp.$touch();
            if (this.$v.otp.$anyError) {
                return;
            }
            request({
                method: 'POST',
                api: '/api/apiVerifyOtp',
                base: true,
                data: {
                    cellphone: this.cellphone,
                    otpCodeUUID: this.otpCodeUUID,
                    userOtpCode: this.otp,
                }
            })
                .then(res => {
                    // 驗證成功
                    this.otpCallback(res.data.otpCodeUUID);
                }).catch(e => {
                    if (e.status === 400) {
                        this.$notify({
                            group: 'alert',
                            title: e.data[0].error,
                            type: 'error',
                        });
                    } else if (e.status === 500) {
                        this.$notify({
                            group: 'alert',
                            title: e.message,
                            type: 'error',
                        });
                    }
                });
        },
        editForm() {
            this.editCallback(true);
            this.otp = '';
            this.$v.otp.$reset();
        },
    },
};
</script>

<style scoped lang="scss">
.otp-form {
    max-width: 540px;
}
.spacing {
    margin-top: 40px;
    margin-bottom: 40px;
}
.background {
    background-color: #f5f5f5;
}
.otp-text {
    color: #999;
}
.radius {
    border-radius: 5px;
}
</style>
